import setting from '../package.json'
export const VERSION = setting.version
